import { EVENTS as GLOBAL_EVENTS } from '@/app/shared/utils/constants';
import ComponentMixin from "../../../shared/mixins/ComponentMixin";
import { isArray, isJson, equalDeep } from '@config/utils';
import { EVENTS } from '../../../shared/config';

export default {
    mixins: [
        ComponentMixin,
    ],
    components: {
        ColumnActions: () => import(/* webpackChunkName: "column-actions" */ "@/app/shared/components/tables/ColumnActions"),
        TableSearch: () => import(/* webpackChunkName: "table-data" */ "@/app/shared/components/tables/DataTable")
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        moduleCode: {
            type: String,
            required: true,
        },
        mapId: {
            type: String,
            required: true,
        },
        panelId: {
            type: String,
            required: true,
        },
        baseTranslateID: {
            type: String,
            default: null,
        },
        eventViewDetail: {
            type: String,
            default: null
        },
        vScope: {
            type: String,
            default: 'form',
        },
        readonlyForm: {
            type: Boolean,
            default: false,
        },
        tableStartLoad: {
            type: Boolean,
            default: false,
        },
        tableColumns: {
            type: Array,
            default: () => {
                return [];
            },
        },
        tableSettings: {
            type: Object,
            default: () => {
                return {
                    sort: "desc",
                    order_by: "code",
                    queryParams: {
                        filters: 'data',
                    },
                };
            },
        },
        tableClass: {
            type: String,
            default: 'table-responsive-sm',
        },
    },
    data() {
        return {
            idPanel: this.panelId,
            actions: {},
        }
    },
    computed: {
        translateID() {
            return `${this.baseTranslateID ?? this.idPanel}`;
        },
        modelTranslateID() {
            return `${this.translateID}.model`
        },
        allowViewDetail() {
            return this.actions?.detail ?? false;
        },
        featureCfg() {
            return this.panel.feature ?? {};
        },
        featureIdProperty() {
            return this.featureCfg.idProperty ?? null;
        },
        featureGeometryProperty() {
            return this.featureCfg.geometryProperty ?? null;
        },
        featurePreserveOnMap() {
            return this.featureCfg.preserveGeometry ?? false;
        },
    },
    methods: {
        onSearched(data) {
            let actions = data?.actions ?? null;
            if (actions) {
                this.actions = Object.assign({}, this.actions, actions);
                this.$emit('searched', {panelId: this.panelId, actions: this.actions});
            }
        },
        onResetSearch() {
            this.clearMap();
            Object.assign(this.$data.actions, this.$options.data().actions);
        },
        onViewDetail(params) {
            if(!this.allowViewDetail) return;

            if(this.eventViewDetail) {
                this.$eventBus.publish(
                    this.moduleCode,
                    this.eventViewDetail,
                    {
                        data: {...params},
                        callback: this.callbackViewDetail
                    }
                );
            }
        },
        onViewOnMap(params) {
            if (this.hasGeometry(params)) {
                this.close();
                this.$eventBus.publish(
                    this.moduleCode,
                    GLOBAL_EVENTS.HIGHLIGHT_FEATURE,
                    {
                        feature: {...params},
                        mapId: this.mapId,
                        options: {
                            idProperty: this.featureIdProperty,
                            geomProperty: this.featureGeometryProperty,
                            preserveGeometry: this.featurePreserveOnMap,
                        }
                    }
                );
            }
        },
        clearMap() {
            this.$eventBus.publish(
                this.moduleCode,
                GLOBAL_EVENTS.CLEAR_HIGHLIGHT_FEATURE,
                {
                    feature: {...params},
                    mapId: this.mapId,
                    options: {
                        idProperty: this.featureIdProperty,
                        geomProperty: this.featureGeometryProperty,
                    }
                }
            );
        },
        loadData(resetPagination = false) {
            let tblSearch = this.$refs[`tblSearch-${this.panelId}`];
            if(tblSearch) {
                tblSearch.search(resetPagination);
            }
        },
        callFn(fnName, params) {
            if (typeof this[fnName] === "function") {
                return this[fnName](params);
            }else{
                return this[fnName];
            }
        },
        getGeometry(obj, property  = this.featureGeometryProperty) {
            let geometry = property in obj ? obj[property] : null;
            return geometry ?
                (isArray(geometry) ? (geometry.length > 0 ? geometry : null) : (isJson(geometry) ? geometry : null)) : null;
        },
        hasGeometry(data) {
            return !!this.getGeometry(data);
        },
        callbackViewDetail(params = {}) {
            const {action, ...rest} = params;
            switch (action) {
                case EVENTS.CREATED:
                case EVENTS.UPDATED:
                case EVENTS.DELETED:
                    this.loadData(false);
                    break;
                default:
                    break;
            }
        },
        close(){
            this.$emit('close');
        },
    },
    watch: {
        isShow: {
            immediate: true,
            handler: function(value) {
                if(value) {
                    this.loadData(false);
                }
            }
        },
        value: {
            immediate: true,
            handler: function(value, oldValue) {
                this.form = this.value;

            }
        },
        form: {
            immediate: false,
            handler: function(value, oldValue) {
                if(this.isShow && !equalDeep(value, oldValue)) {
                    this.loadData(true)
                }
            }
        }
    }
}